const RoundedContainer = ({ children, className }) => {
  return (
    <div className={`p-2 bg-white rounded-2xl mt-3 shadow ${className}`}>
      {children}
    </div>
  );
};

export default RoundedContainer;
